<template>
  <v-container fluid pa-0>
    <InfoClient
      pageTitle="Cliente"
      :cliente="cliente"
      @refreshCliente="refreshCliente"
    >
      <SearchClient @searchClient="searchClient" />
    </InfoClient>
    <TabsClient 
      pageTitle="Atividades"
      :qtdeAtividades="allAtividades.length"
      :qtdeFinalizadas="completedAtividades.length"
      :qtdePendentes="pendingAtividades.length"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
      @finalizaItemSelected="finalizaItemSelected"
      @voltaStatusItemSelected="voltaStatusItemSelected"
      @abreModalEditPrevisao="abreModalEditPrevisao"
      @abreModalEditSituacao="abreModalEditSituacao"
      @abreModalEditResponsavel="abreModalEditResponsavel"
      @abreModalEditColaborador="abreModalEditColaborador"
      @abreModalEditCliente="abreModalEditCliente"
      @abreModalEditTipoAtividade="abreModalEditTipoAtividade"
      @abreModalEditTag="abreModalEditTag"
      @abreModalEditWorkflow="abreModalEditWorkflow"
      @abreModalSetaOcorrencia="abreModalSetaOcorrencia"
      @abreModalDuplicaAtividade="abreModalDuplicaAtividade"
      @searchAtividade="searchAtividade"
      @refreshAtividadesCliente="searchClient"
    >
      <v-tooltip slot="adicionaAtividade" bottom>
        <ModalCadastro :cliente="cliente" slot="activator" />
        <span>Adicionar</span>
      </v-tooltip>
      <Grid :items="pendingAtividades" :searchTerm="searchTerm" :loading="searchLoading" slot="pendentes" />
      <Grid :items="completedAtividades" :searchTerm="searchTerm" :loading="searchLoading" slot="finalizadas" />
      <Grid :items="allAtividades" :searchTerm="searchTerm" :loading="searchLoading" slot="todas" />
    </TabsClient>
    <!-- Modal Setar Previsão -->
    <ModalEditPrevisao 
      v-model="dialogPrevisao"
      :atividade="atividade"
      :loading="setaPrevisaoLoading"
      @setaPrevisaoSelected="setaPrevisaoItemSelected"
    />
    <!-- Modal Setar Situação -->
    <ModalEditSituacao 
      v-model="dialogSituacao"
      :atividade="atividade"
      :loading="setaSituacaoLoading"
      @setaSituacaoSelected="setaSituacaoItemSelected"
    />
    <!-- Modal Setar Responsável -->
    <ModalEditResponsavel 
      v-model="dialogResponsavel"
      :atividade="atividade"
      :loading="setaResponsavelLoading"
      @setaResponsavelSelected="setaResponsavelItemSelected"
    />
    <!-- Modal Setar Colaborador -->
    <ModalEditColaborador 
      v-model="dialogColaborador"
      :atividadeColaborador="atividadeColaborador"
      :loading="setaColaboradorLoading"
      @setaColaboradorSelected="setaColaboradorItemSelected"
    />
    <!-- Modal Setar Cliente -->
    <ModalEditCliente 
      v-model="dialogCliente"
      :atividadeCliente="atividadeCliente"
      :loading="setaClienteLoading"
      @setaClienteSelected="setaClienteItemSelected"
    />
    <!-- Modal Setar Tag -->
    <ModalEditTag 
      v-model="dialogTag"
      :atividadeTag="atividadeTag"
      :loading="setaTagLoading"
      @setaTagSelected="setaTagItemSelected"
    />
    <!-- Modal Setar Ocorrencia -->
    <ModalSetaOcorrencia 
      v-model="dialogOcorrencia"
      :loading="setaOcorrenciaLoading"
      :atividadeOcorrencia="atividadeOcorrencia"
      @setaOcorrenciaSelected="setaOcorrenciaItemSelected"
    />
    <!-- Modal Setar Workflow -->
    <ModalEditWorkflow 
      v-model="dialogWorkflow"
      :atividade="atividade"
      :loading="setaWorkflowLoading"
      @setaWorkflowSelected="setaWorkflowItemSelected"
    />
    <!-- Modal Setar Tipo Atividade -->
    <ModalEditTipoAtividade 
      v-model="dialogTipoAtividade"
      :atividade="atividade"
      :loading="setaTipoAtividadeLoading"
      @setaTipoAtividadeSelected="setaTipoAtividadeItemSelected"
    />
    <!-- Modal Duplicar Atividade -->
    <ModalDuplicaAtividade 
      v-model="dialogDuplicaAtividade"
      :atividade="atividade"
      :loading="duplicaAtividadeLoading"
      @duplicaAtividade="duplicaAtividadeItem"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import SearchClient from "@/components/helpdesk/SearchClient";
import InfoClient from "@/components/helpdesk/InfoClient";
import TabsClient from "@/components/helpdesk/TabsClient";
import Grid from "@/components/shared/Grid";
import Atividade from '@/domain/atividade/Atividade';
import AtividadeColaborador from '@/domain/atividade/AtividadeColaborador';
import AtividadeCliente from '@/domain/atividade/AtividadeCliente';
import AtividadeTag from '@/domain/atividade/AtividadeTag';
import ModalEditPrevisao from '@/components/atividade/ModalEditPrevisao';
import ModalEditSituacao from '@/components/atividade/ModalEditSituacao';
import ModalEditResponsavel from '@/components/atividade/ModalEditResponsavel';
import ModalEditColaborador from '@/components/atividade/ModalEditColaborador';
import ModalEditCliente from '@/components/atividade/ModalEditCliente';
import ModalEditTag from '@/components/atividade/ModalEditTag';
import ModalCadastro from '@/components/atividade/ModalCadastro';
import ModalEditTipoAtividade from '@/components/atividade/ModalEditTipoAtividade';
import ModalDuplicaAtividade from '@/components/atividade/ModalDuplicaAtividade';
import ModalSetaOcorrencia from '@/components/atividade/ModalSetaOcorrencia';
import ModalEditWorkflow from '@/components/atividade/ModalEditWorkflow';
import AtividadeOcorrencia from '@/domain/atividade/AtividadeOcorrencia';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: "Helpdesk",
  data: () => ({
    searchTerm: '',
    searchLoading: false,
    cliente: null,
    atividade: null,
    atividadeOcorrencia: new AtividadeOcorrencia(),
    atividadeColaborador: null,
    atividadeCliente: null,
    atividadeTag: null,
    dialogPrevisao: false,
    dialogSituacao: false,
    dialogResponsavel: false,
    dialogColaborador: false,
    dialogCliente: false,
    dialogTag: false,
    dialogWorkflow: false,
    dialogOcorrencia: false,
    dialogTipoAtividade: false,
    dialogDuplicaAtividade: false,
    setaPrevisaoLoading: false,
    setaSituacaoLoading: false,
    setaResponsavelLoading: false,
    setaColaboradorLoading: false,
    setaClienteLoading: false,
    setaTagLoading: false,
    setaWorkflowLoading: false,
    setaOcorrenciaLoading: false,
    setaTipoAtividadeLoading: false,
    duplicaAtividadeLoading: false
  }),
  components: {
    SearchClient,
    InfoClient,
    TabsClient,
    Grid,
    ModalEditPrevisao,
    ModalEditSituacao,
    ModalEditResponsavel,
    ModalEditColaborador,
    ModalEditCliente,
    ModalEditTag,
    ModalCadastro,
    ModalEditTipoAtividade,
    ModalDuplicaAtividade,
    ModalSetaOcorrencia,
    ModalEditWorkflow,
  },
  computed: {
    ...mapGetters(["atividades", "atividadesSelected"]),
    allAtividades() {
      return this.atividades;
    },
    pendingAtividades() {
      // return this.atividades.filter(a => a.Status == "P");
      return this.atividades.filter(a => a.Status.includes('P'));
    },
    completedAtividades() {
      // return this.atividades.filter(a => a.Status == "F");
      return this.atividades.filter(a => a.Status.includes('F'));
    },
    canceledAtividades() {
      // return this.atividades.filter(a => a.Status == "C");
      return this.atividades.filter(a => a.Status.includes('C'));
    }
  },
  methods: {
    ...mapActions([
      'fetchAtividadesClienteNode', 
      'fetchClienteById', 
      'updateAtividadeNode',
      'deleteAtividadeNode', 
      'finalizarAtividadeNode',
      'voltarStatusAtividade',
      'resetAtividadesSelected',
      'addAtividadeColaboradorNode',
      'addClienteAtividadeSelectedNode',
      'addAtividadeTag',
      'duplicaAtividade',
      'addOcorrenciaNode',

    ]),
    ...mapMutations(["showNotification", "closeNotification"]),
    searchAtividade(term) {
      this.searchTerm = term;
    },
    async searchClient(id) {
      this.searchLoading = true;
      if (id) {
        this.cliente = await this.fetchClienteById(id);
        localStorage.setItem("searchClient", JSON.stringify(this.cliente));
        await this.fetchAtividadesClienteNode(id);
        this.searchLoading = false;
      } else {
        await this.fetchAtividadesClienteNode(this.cliente.IdCliente);
        this.searchLoading = false;
      }
    },
    async refreshCliente(id) {
      if (id) {
        this.cliente = await this.fetchClienteById(id);
        localStorage.setItem("searchClient", JSON.stringify(this.cliente));
      }
    },
    voltaStatusItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja voltar o status de: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.voltarStatusAtividade(item.IdAtividade)));
          Promise.all(promises)
            .then(() => this.resetAtividadesSelected());
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para voltar o status.', status: 'error' });
      }
    },
    abreModalEditPrevisao(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogPrevisao = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogPrevisao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a previsão.', status: 'error' });
      }
    },
    abreModalEditSituacao(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogSituacao = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogSituacao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a situação.', status: 'error' });
      }
    },
    abreModalEditResponsavel(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogResponsavel = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogResponsavel = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o responsável.', status: 'error' });
      }
    },
    abreModalEditTipoAtividade(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogTipoAtividade = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogTipoAtividade = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o tipo de atividade.', status: 'error' });
      }
    },
    abreModalEditColaborador(atividade) {
      if (atividade !== null) {
        this.atividadeColaborador.IdAtividade = atividade.IdAtividade;
        this.dialogColaborador = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeColaborador = null;
        this.dialogColaborador = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o colaborador.', status: 'error' });
      }
    },
    abreModalEditCliente(atividade) {
      if (atividade !== null) {
        this.atividadeCliente.IdAtividade = atividade.IdAtividade;
        this.dialogCliente = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeCliente = null;
        this.dialogCliente = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o cliente.', status: 'error' });
      }
    },
    abreModalEditTag(atividade) {
      if (atividade !== null) {
        this.atividadeTag.IdAtividade = atividade.IdAtividade;
        this.dialogTag = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeTag = null;
        this.dialogTag = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a tag.', status: 'error' });
      }
    },
    abreModalEditWorkflow(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogWorkflow = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogWorkflow = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o workflow.', status: 'error' });
      }
    },
    abreModalSetaOcorrencia(atividade) {
      if (atividade !== null) {
        this.atividadeOcorrencia.IdAtividade = atividade.IdAtividade;
        this.dialogOcorrencia = true;
      } else if (this.atividadesSelected.length) {
        this.dialogOcorrencia = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a ocorrência.', status: 'error' });
      }
    },
    abreModalDuplicaAtividade(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogDuplicaAtividade = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogDuplicaAtividade = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para duplicar.', status: 'error' });
      }
    },
    editItemSelected() {
      if (this.atividadesSelected.length) {
        this.searchTerm ? localStorage.setItem('searchTerm', this.searchTerm) : localStorage.setItem('searchTerm', '');
        // localStorage.setItem('pagConfig', JSON.stringify(this.pagConfig));
        let id = this.atividadesSelected[this.atividadesSelected.length - 1].IdAtividade;
        this.$router.push({ name: 'altera atividade', params: { id } });
        this.resetAtividadesSelected();
      } else {
        this.showNotification({ text: 'Selecione uma atividade para alterar.', status: 'error' });
      }
    },
    deleteItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja excluir: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => {
            promises.push(this.deleteAtividadeNode(item.IdAtividade));
          });
          Promise.all(promises)
            .then(() => {
              this.resetAtividadesSelected();
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              // this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir as atividades: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para excluir.', status: 'error' });
      }
    },
    finalizaItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja finalizar: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.finalizarAtividadeNode(item)));

          Promise.all(promises)
            .then(() => this.resetAtividadesSelected());
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para finalizar.', status: 'error' });
      }
    },
    setaPrevisaoItemSelected(previsao) {
      if (this.atividadesSelected.length) {
        this.setaPrevisaoLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.DataPrevisao = previsao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogPrevisao = false;
            this.resetAtividadesSelected();
            this.setaPrevisaoLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a previsão.`, status: 'error' });
      }
    },
    setaSituacaoItemSelected(situacao) {
      if (this.atividadesSelected.length) {
        this.setaSituacaoLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdSituacao = situacao.IdSituacao;
          atividade.Situacao = situacao.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogSituacao = false;
            this.resetAtividadesSelected();
            this.setaSituacaoLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a situação.`, status: 'error' });
      }
    },
    setaResponsavelItemSelected(responsavel) {
      if (this.atividadesSelected.length) {
        this.setaResponsavelLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item }
          atividade.IdResponsavel = responsavel.IdColaborador;
          atividade.Responsavel = responsavel.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogResponsavel = false;
            this.resetAtividadesSelected();
            this.setaResponsavelLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o responsável.`, status: 'error' });
      }
    },
    setaTipoAtividadeItemSelected(tipoAtividade) {
      if (this.atividadesSelected.length) {
        this.setaTipoAtividadeLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdTipoAtividade = tipoAtividade.IdTipoAtividade;
          atividade.TipoAtividade = tipoAtividade.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTipoAtividade = false;
            this.resetAtividadesSelected();
            this.setaTipoAtividadeLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o tipo atividade.`, status: 'error' });
      }
    },
    setaColaboradorItemSelected(colaborador) {
      if (this.atividadesSelected.length) {
        this.setaColaboradorLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeColaborador = new AtividadeColaborador();
          atividadeColaborador.IdAtividade = item.IdAtividade;
          atividadeColaborador.IdColaborador = colaborador.IdColaborador;
          atividadeColaborador.Colaborador = colaborador.Descricao;
          promises.push(this.addAtividadeColaboradorNode(atividadeColaborador));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogColaborador = false;
            this.resetAtividadesSelected();
            this.setaColaboradorLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o colaborador.`, status: 'error' });
      }
    },
    setaClienteItemSelected(cliente) {
      if (this.atividadesSelected.length) {
        this.setaClienteLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeCliente = new AtividadeCliente();
          atividadeCliente.IdAtividade = item.IdAtividade;
          atividadeCliente.IdCliente = cliente.IdCliente;
          atividadeCliente.Fantasia = cliente.Fantasia;
          promises.push(this.addClienteAtividadeSelectedNode(atividadeCliente));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogCliente = false;
            this.resetAtividadesSelected();
            this.setaClienteLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o cliente.`, status: 'error' });
      }
    },
    setaTagItemSelected(tag) {
      if (this.atividadesSelected.length) {
        this.setaTagLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeTag = new AtividadeTag();
          atividadeTag.IdAtividade = item.IdAtividade;
          atividadeTag.IdTag = tag.IdTag;
          atividadeTag.Descricao = tag.Descricao;
          promises.push(this.addAtividadeTag(atividadeTag));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTag = false;
            this.resetAtividadesSelected();
            this.setaTagLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a tag.`, status: 'error' });
      }
    },
    async setaOcorrenciaItemSelected(ocorrencia) {
      if (this.atividadesSelected.length) {
        this.setaOcorrenciaLoading = true;

        for (const atividade of this.atividadesSelected) {
          ocorrencia.IdAtividade = atividade.IdAtividade;
          await this.addOcorrenciaNode(ocorrencia);
        }
        this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
        this.dialogOcorrencia = false;
        this.resetAtividadesSelected();
        this.atividadeOcorrencia = new AtividadeOcorrencia();
        this.setaOcorrenciaLoading = false;
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a ocorrência.`, status: 'error' });
      }
    },
    setaWorkflowItemSelected(workflow) {
      if (this.atividadesSelected.length) {
        this.setaWorkflowLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdWorkflow = workflow.IdWorkflow;
          atividade.Workflow = workflow.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogWorkflow = false;
            this.resetAtividadesSelected();
            this.setaWorkflowLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o workflow.`, status: 'error' });
      }
    },
    duplicaAtividadeItem(obj) {
      if (obj.atividades.length) {
        this.duplicaAtividadeLoading = true;
        this.duplicaAtividade(obj)
          .then(() => {
            this.dialogDuplicaAtividade = false;
            this.atividade = new Atividade();
            this.resetAtividadesSelected();
            this.duplicaAtividadeLoading = false;
            this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
          })
          .catch(error => {
            this.showNotification({ text: `Ocorreu um erro ao duplicar a(s) atividade(s) ${error}`, status: 'error' })
            this.duplicaAtividadeLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para duplicar.`, status: 'error' });
      }
    },
  },
  async created() {
    changePageTitle('Helpdesk');
    let clienteId = null;
    if (JSON.parse(localStorage.getItem("searchClient")) !== null) {
      clienteId = JSON.parse(localStorage.getItem("searchClient")).IdCliente;
    } else {
      clienteId = null;
    }

    if (clienteId) {
      this.cliente = await this.fetchClienteById(clienteId);
      await this.fetchAtividadesClienteNode(this.cliente.IdCliente)
    }
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>